<ng-container *ngTemplateOutlet="currentView" />
